import { render, staticRenderFns } from "./BaseSection.vue?vue&type=template&id=1fc95762&scoped=true&"
import script from "./BaseSection.vue?vue&type=script&lang=js&"
export * from "./BaseSection.vue?vue&type=script&lang=js&"
import style0 from "./BaseSection.vue?vue&type=style&index=0&id=1fc95762&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc95762",
  null
  
)

component.options.__file = "BaseSection.vue"
export default component.exports